import React from 'react';
import { resolveStyle } from '../base_components';

import { useNavigate } from '../../tools/router';
import { stopAll } from '../../tools/util';

type Props = {
  style?: any;
  className?: string;
  url: string;
  children?: any;
  href?: any;
  target?: any;
  onPress?: (event?: any) => any;
};
export default function Link(props: Props) {
  const { style, className: extraClass, url, onPress, ...other_props } = props;
  const navigate = useNavigate();
  if (
    !other_props.target &&
    (url.startsWith('http') || url.startsWith('tel') || url.startsWith('mail'))
  ) {
    other_props.target = '_blank';
  }
  function _onPress(e: any) {
    let handle = onPress?.(e);
    if (handle !== false) {
      handle = other_props.target !== '_blank';
      if (handle) {
        stopAll(e);
        navigate(encodeURI(url));
      }
    }
    return !handle;
  }

  const { className, inlineStyle } = resolveStyle(style, extraClass);
  return (
    <a
      className={'base-component-link ' + className}
      style={inlineStyle}
      {...other_props}
      href={url}
      onClick={_onPress}
    >
      {props.children}
    </a>
  );
}
